import { TXGridTemplate } from "../../../types/common/templates.types";
import { X_GRID_COL_2 } from "./col2";
import { X_GRID_COL_3 } from "./col3";
import { X_GRID_COL_4 } from "./col4";

export const X_GRID_TEMPLATES: TXGridTemplate = {
  ...X_GRID_COL_2,
  ...X_GRID_COL_3,
  ...X_GRID_COL_4,
};
